

<ol class="list-imageResults" id="container-imageListComponent">
  <li *ngFor="let image of images; trackBy: trackByFn">
    <figure>
      <a (click)="pushResultImgObjClickToGA(image.id, image)" [routerLink]="[imgUrl +  image.id]" [queryParams]="{'searchId': image.searchId}">
        <img *ngIf="image.altText" [src]="image.src" [alt]="image.altText | pqCleanText: true | pqImageTitleFormat">
        <img *ngIf="image.altText === ''" [src]="image.src" [alt]="'image thumbnail'">
        <figcaption *ngIf="image.title" [innerHTML]="image.title | pqCleanText | pqImageTitleFormat | pqTruncate: titleCharLimit"></figcaption>
      </a>
    </figure>
  </li>
</ol>
